'use strict';/* global define */define('modules/time/values/reminder-durations/index',['require','exports','module'],function(require,exports,module){'use strict';module.exports=['PT5M','PT10M','PT15M','PT30M','PT45M','PT60M'];});
